import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';

export const ChargeDetail: React.FC<{
  transkey: string;
  keyValues: Record<string, any>;
}> = ({ transkey, keyValues }) => {
  return (
    <Text dataHook={`charge-details__${transkey}`} secondary>
      <Trans
        i18nKey={`charge-locator.results-page.field-name.${transkey}`}
        values={keyValues}
        count={keyValues.quantity}
      >
        charge-locator.results-page.
        <Text tagName="span" secondary={false} weight="normal">
          field-name.{transkey}
        </Text>
      </Trans>
    </Text>
  );
};
